import { useUnit } from 'effector-react'
import { $disabled, $error, $status, $value, emailChanged, emailCleared, emailSubmitted } from './verificar-email.model'

// NOTA: `useAuthStore` (zustand) fue retirado en la migración al design-system.
// Al ser `/onboarding` una ruta pública, no hay usuario autenticado del cual
// precargar el email, por lo que se eliminó el efecto de precarga.
export function useVerificarEmail() {
  return useUnit({
    error: $error,
    value: $value,
    status: $status,
    disabled: $disabled,
    onChange: emailChanged,
    onReset: emailCleared,
    onSubmit: emailSubmitted,
  })
}
